import React from 'react'
import { Button, Toolbar, Typography, IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

import { useDrawer, useAuth } from '~/src/hooks'
import { AppBarStyled } from './Header.styles'

export type THeaderProps = {
  title: string
  open?: boolean
}

/**
 * Header Component
 *
 * @example
 * ```ts
 *  <Header title="Top" open={false} />
 * ```
 * @param __namedParameters THeaderProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const Header: React.FC<THeaderProps> = ({ title = 'ホーム', open = false }): JSX.Element => {
  const { handleDrawerOpen, handleDrawerClose } = useDrawer()
  const { logout } = useAuth()
  return (
    <AppBarStyled position="fixed" open={open} sx={{ background: '#1F4266' }}>
      <Toolbar sx={{ height: '65px' }}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2, ml: 0 }}
          onClick={open ? handleDrawerClose : handleDrawerOpen}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          variant="h6"
          color="inherit"
          component="h1"
          fontSize="20px"
          sx={{ flexGrow: 1 }}
        >
          {title}
        </Typography>
        <Button color="inherit" sx={{ fontSize: '14px' }} onClick={logout}>
          Logout
        </Button>
      </Toolbar>
    </AppBarStyled>
  )
}
